import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.splice.js";
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("th", null, "Davčna številka", -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("th", null, "Naziv", -1);

var _hoisted_3 = /*#__PURE__*/_createVNode("th", null, "Datum plačila", -1);

var _hoisted_4 = /*#__PURE__*/_createVNode("th", {
  class: "text-right"
}, "Znesek", -1);

var _hoisted_5 = /*#__PURE__*/_createVNode("th", null, "Valuta", -1);

var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  width: "50"
};
var _hoisted_9 = {
  key: 0
};
var _hoisted_10 = {
  class: "padding-bottom12 padding-top12"
};
var _hoisted_11 = {
  class: "padding-bottom12 padding-top12"
};
var _hoisted_12 = {
  class: "padding-bottom12 padding-top12"
};
var _hoisted_13 = {
  class: "padding-bottom12 padding-top12"
};
var _hoisted_14 = {
  class: "padding-bottom12 padding-top12"
};
var _hoisted_15 = {
  class: "colRed padding-bottom12 padding-top12"
};
var _hoisted_16 = {
  class: "colRed padding-bottom12 padding-top12"
};
var _hoisted_17 = {
  class: "colRed padding-bottom12 padding-top12"
};
var _hoisted_18 = {
  class: "colRed padding-bottom12 padding-top12 text-right"
};
var _hoisted_19 = {
  class: "colRed padding-bottom12 padding-top12"
};
var _hoisted_20 = {
  class: "text-center"
};

var _hoisted_21 = /*#__PURE__*/_createVNode("b", null, "Briši", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_InputText = _resolveComponent("InputText");

  var _component_InputWrapper = _resolveComponent("InputWrapper");

  var _component_InputDate = _resolveComponent("InputDate");

  var _component_InputNumeric = _resolveComponent("InputNumeric");

  var _component_Select = _resolveComponent("Select");

  return _openBlock(), _createBlock("table", {
    class: ["table compact", {
      'table-hover': _ctx.disabled
    }]
  }, [_createVNode("thead", null, [_hoisted_1, _hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5, _ctx.disabled ? (_openBlock(), _createBlock("th", _hoisted_6, "Datum poročanja")) : _createCommentVNode("", true), _ctx.cancellation ? (_openBlock(), _createBlock("th", _hoisted_7, "Opomba")) : _createCommentVNode("", true), _createVNode("th", _hoisted_8, [!_ctx.disabled || _ctx.canCancel ? (_openBlock(), _createBlock("span", _hoisted_9, "Akcija")) : _createCommentVNode("", true)])]), _createVNode("tbody", null, [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, function (t, index) {
    return _openBlock(), _createBlock("tr", {
      key: t.id
    }, [!_ctx.disabled ? (_openBlock(), _createBlock(_Fragment, {
      key: 0
    }, [t.idPrev === null ? (_openBlock(), _createBlock(_Fragment, {
      key: 0
    }, [_createVNode("td", null, [_createVNode("div", _hoisted_10, [_createVNode(_component_InputWrapper, {
      errors: _ctx.errorMap(_ctx.$appErrors, "".concat(_ctx.errorPrefix, "transactionList[").concat(index, "].taxNumber"))
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_InputText, {
          modelValue: t.taxNumber,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return t.taxNumber = $event;
          },
          onBlur: function onBlur($event) {
            return _ctx.checkTaxNumber(t);
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])];
      }),
      _: 2
    }, 1032, ["errors"])])]), _createVNode("td", null, [_createVNode("div", _hoisted_11, [_createVNode(_component_InputWrapper, {
      errors: _ctx.errorMap(_ctx.$appErrors, "".concat(_ctx.errorPrefix, "transactionList[").concat(index, "].description"))
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_InputText, {
          modelValue: t.description,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return t.description = $event;
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue"])];
      }),
      _: 2
    }, 1032, ["errors"])])]), _createVNode("td", null, [_createVNode("div", _hoisted_12, [_createVNode(_component_InputWrapper, {
      errors: _ctx.errorMap(_ctx.$appErrors, "".concat(_ctx.errorPrefix, "transactionList[").concat(index, "].datePayment"))
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_InputDate, {
          modelValue: t.datePayment,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return t.datePayment = $event;
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue"])];
      }),
      _: 2
    }, 1032, ["errors"])])]), _createVNode("td", null, [_createVNode("div", _hoisted_13, [_createVNode(_component_InputWrapper, {
      errors: _ctx.errorMap(_ctx.$appErrors, "".concat(_ctx.errorPrefix, "transactionList[").concat(index, "].amount"))
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_InputNumeric, {
          decimals: 2,
          modelValue: t.amount,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return t.amount = $event;
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue"])];
      }),
      _: 2
    }, 1032, ["errors"])])]), _createVNode("td", null, [_createVNode("div", _hoisted_14, [_createVNode(_component_InputWrapper, {
      errors: _ctx.errorMap(_ctx.$appErrors, "".concat(_ctx.errorPrefix, "transactionList[").concat(index, "].currency.id"))
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_Select, {
          data: _ctx.currencyList,
          modelValue: t.currency.id,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return t.currency.id = $event;
          }
        }, null, 8, ["data", "modelValue", "onUpdate:modelValue"])];
      }),
      _: 2
    }, 1032, ["errors"])])])], 64)) : (_openBlock(), _createBlock(_Fragment, {
      key: 1
    }, [_createVNode("td", _hoisted_15, _toDisplayString(t.taxNumber), 1), _createVNode("td", _hoisted_16, _toDisplayString(t.description), 1), _createVNode("td", _hoisted_17, _toDisplayString(_ctx.formatDate(t.datePayment)), 1), _createVNode("td", _hoisted_18, _toDisplayString(_ctx.formatNumber(t.amount, 2)), 1), _createVNode("td", _hoisted_19, _toDisplayString(t.currency.text), 1)], 64)), _ctx.cancellation ? (_openBlock(), _createBlock("td", {
      key: 2,
      class: {
        colRed: t.idPrev
      }
    }, _toDisplayString(t.idPrev ? 'Storno' : '') + " " + _toDisplayString(t.cancelled ? 'Stornirano' : ''), 3)) : _createCommentVNode("", true), _createVNode("td", _hoisted_20, [!_ctx.disabled ? (_openBlock(), _createBlock("a", {
      key: 0,
      href: "",
      onClick: _withModifiers(function ($event) {
        return _ctx.modelValue.splice(index, 1);
      }, ["prevent"])
    }, [_hoisted_21], 8, ["onClick"])) : _createCommentVNode("", true)])], 64)) : (_openBlock(), _createBlock(_Fragment, {
      key: 1
    }, [_createVNode("td", {
      class: [{
        colRed: t.idPrev
      }, {
        'line-through': t.cancelled
      }]
    }, _toDisplayString(t.taxNumber), 3), _createVNode("td", {
      class: [{
        colRed: t.idPrev
      }, {
        'line-through': t.cancelled
      }]
    }, _toDisplayString(t.description), 3), _createVNode("td", {
      class: [{
        colRed: t.idPrev
      }, {
        'line-through': t.cancelled
      }]
    }, _toDisplayString(_ctx.formatDate(t.datePayment)), 3), _createVNode("td", {
      class: ["text-right", [{
        colRed: t.idPrev
      }, {
        'line-through': t.cancelled
      }]]
    }, _toDisplayString(_ctx.formatNumber(t.amount, 2)), 3), _createVNode("td", {
      class: [{
        colRed: t.idPrev
      }, {
        'line-through': t.cancelled
      }]
    }, _toDisplayString(t.currency.text), 3), _ctx.disabled ? (_openBlock(), _createBlock("td", {
      key: 0,
      class: [{
        colRed: t.idPrev
      }, {
        'line-through': t.cancelled
      }]
    }, _toDisplayString(_ctx.formatDate(t.dateCreate, 'DD.MM.YYYY HH:mm')), 3)) : _createCommentVNode("", true), _ctx.cancellation ? (_openBlock(), _createBlock("td", {
      key: 1,
      class: [{
        colRed: t.idPrev
      }]
    }, _toDisplayString(t.idPrev ? 'Storno' : '') + " " + _toDisplayString(t.cancelled ? 'Stornirano' : ''), 3)) : _createCommentVNode("", true), _createVNode("td", null, [_ctx.canCancel && t.idPrev === null && t.cancelled !== true ? (_openBlock(), _createBlock("a", {
      key: 0,
      href: "",
      class: "blue text-bold",
      onClick: _withModifiers(function ($event) {
        return _ctx.$emit('onCancel', t);
      }, ["prevent"])
    }, "Storniraj", 8, ["onClick"])) : _createCommentVNode("", true)])], 64))]);
  }), 128))])], 2);
}